import React from 'react';
import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";
import ScrollToTop from "react-scroll-to-top";

import {android,iphone } from '../../constants/Images';


const Footer = () => {
 return (
     <>   
    <footer>
        <div className="footer-bottom">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12 footer-icon">

                          <ul>
                             <li><a href="https://www.facebook.com/superplayerauction" target="_blank"><AiIcons.AiFillFacebook></AiIcons.AiFillFacebook></a></li>
                             <li><a href="#" target="_blank"><AiIcons.AiFillInstagram></AiIcons.AiFillInstagram></a></li>
                             <li><a href="https://youtu.be/vCcppfCmlaQ" target="_blank"><IoIcons.IoLogoYoutube></IoIcons.IoLogoYoutube></a></li>
                             </ul><ul><li><a href="https://play.google.com/store/apps/details?id=com.harshtechnology.player_auction" target="_blank">
                       <img src={android} className="" alt="android"/>
                    </a></li>
                    <li><a className="" href="https://apps.apple.com/us/app/super-player-auction/id1472722558" target="_blank"> 
                    <img src={iphone} className="" alt="iphone"/></a></li>
                           </ul>

                        <div className="col-md-12 footer-icon-p">
                            <p>&copy;  Copyright Super Player Auction . All Rights Reserved</p>
                        </div>
                   
                    </div>
                </div>

            </div>
        </div>
    </footer>  

    <ScrollToTop smooth></ScrollToTop>    

    </> 
    )
}

export default Footer
